export const pushToDataLayer = (key: string, ...args: any[]) => {
  const _hsq = (window._hsq = window._hsq || []);
  _hsq.push([key, ...args]);

  // console.debug(`[HubSpot]`, key, ...args);
};
